export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14926.68672639.jpg";